import { render, staticRenderFns } from "./diagnosticRecords.vue?vue&type=template&id=28ae1d36&scoped=true"
import script from "./diagnosticRecords.vue?vue&type=script&lang=js"
export * from "./diagnosticRecords.vue?vue&type=script&lang=js"
import style0 from "./diagnosticRecords.vue?vue&type=style&index=0&id=28ae1d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae1d36",
  null
  
)

export default component.exports